<script setup lang="ts">
import { useClaims } from '@auth/useClaims';
import { getSurenetUrl } from '@menu-lib/urlHelper';
import { VButton } from '@shared/component/VButton';
import VMenuButton from '@shared/component/VMenuButton/VMenuButton.vue';
import { toRefs } from 'vue';
import { useFishCheckLink } from '@crm-lib/relatiegegevens/useFishCheckLink';
import { useRoydataLink } from '@crm-lib/relatiegegevens/useRoydataLink';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);

const claims = useClaims();

const fishCheckLink = useFishCheckLink(relatienummer);
const roydataLink = useRoydataLink(relatienummer);
</script>

<template>
  <div class="flex flex-col items-stretch gap-2 p-4">
    <VButton
      :href="
        getSurenetUrl(
          `/content/plugins/composemail/relatie/verstuurmail-init.asp?relatienummer=${props.relatienummer}&callback=/paginaladen.asp?url=/app/crm/relatiegegevens/${props.relatienummer}`,
          claims?.isWebmodule ?? false,
        )
      "
      inverted
      prepend-icon="fas fa-envelope"
    >
      Mail versturen
    </VButton>
    <VMenuButton
      v-if="claims?.isInternal"
      :button-props="{ inverted: true }"
      :menu-props="{
        pt: { root: { class: 'w-52' } },
        ptOptions: { mergeProps: true },
        model: [
          {
            ...fishCheckLink,
          },
          {
            ...roydataLink,
          },
        ],
      }"
    >
      Solera opties
    </VMenuButton>
  </div>
</template>
